import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

/**
 * Encuadre común de las subpáginas de /me/security dentro del AppShell.
 *
 * El AppShell ya provee sidebar + header (con el título de la SECCIÓN "Seguridad") y un área de
 * contenido ancha. Cada subpágina va anclada arriba-izquierda con su propio título (`<h1>`) y el
 * contenido debajo, con el mismo `space-y-4`. Es el patrón que ya usan change-password /
 * mfa-preference / el índice de seguridad; este wrapper lo centraliza para que las pantallas MFA
 * (email, TOTP, SMS) queden idénticas y no floten como una card suelta en un mar de espacio vacío.
 *
 * `centered` (opt-in): las pantallas MFA focalizadas (email, TOTP, SMS) son de un solo propósito
 * —ingresar/confirmar un OTP o escanear un QR— así que se ven mejor como una card enfocada: el
 * bloque (título + contenido, acotado a `max-w-md`) se centra horizontalmente (`mx-auto`) y baja
 * del borde superior (`pt-8`). Sin la prop, el encuadre sigue anclado arriba-izquierda como el
 * resto de /me/security (change-password / mfa-preference / índice) — así no las degradamos.
 */
export function SecurityPageSection({
    title,
    children,
    className,
    centered = false,
}: {
    title: string;
    children: ReactNode;
    className?: string;
    centered?: boolean;
}) {
    return (
        <div className={cn('space-y-4', centered && 'mx-auto max-w-md pt-8', className)}>
            <h1 className="text-2xl font-semibold">{title}</h1>
            {children}
        </div>
    );
}
